import * as XLSX from 'xlsx';

export const importFields = [
  ['name','Nombre',['nombre','cliente','nombre completo','name']],
  ['surname','Apellido',['apellido','apellidos','last name']],
  ['phone','Teléfono',['telefono','celular','phone','whatsapp']],
  ['email','Correo',['email','correo','correo electronico']],
  ['notes','Notas',['notas','observaciones','notes']],
  ['tags','Etiquetas',['etiquetas','tags']],
  ['externalId','ID de origen',['id','id cliente','codigo cliente']],
  ['birthday','Nacimiento (texto original)',['fecha de nacimiento','cumpleanos','birthday']],
  ['address','Dirección',['direccion','domicilio','address']],
  ['importedTotalBookings','Reservas históricas',['numero de reservas','total reservas','reservas']],
  ['importedLastBookingAtText','Última visita',['ultima visita','ultima fecha de reserva']],
];
const norm = value => String(value||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').trim().toLowerCase();
export function suggestMapping(headers) {
  return Object.fromEntries(importFields.map(([key,,aliases]) => [key, String(headers.findIndex(h=>aliases.includes(norm(h))))]).filter(([,v])=>v!=='-1'));
}
export async function readImportWorkbook(file) {
  if(file.size > 10 * 1024 * 1024) throw Error('El archivo supera 10 MB. Divide la exportación en archivos más pequeños.');
  const isCsv=/\.csv$/i.test(file.name);
  if(!/\.(csv|xlsx|xls)$/i.test(file.name)) throw Error('Usa un archivo Excel o CSV.');
  const book=XLSX.read(isCsv ? await file.text() : await file.arrayBuffer(),{type:isCsv?'string':'array',raw:true});
  return book.SheetNames.map(name=>({name,rows:XLSX.utils.sheet_to_json(book.Sheets[name],{header:1,defval:'',raw:false})}));
}
export function prepareImport(rows, mapping, source='Archivo') {
  const [headers=[],...body]=rows;
  if(body.length>5000) return {customers:[],errors:[{row:1,message:"Máximo 5.000 filas por carga. Divide el archivo."}]};
  const errors=[],customers=[],seen=new Map();
  body.forEach((row,index)=>{
    if(!row.some(v=>String(v).trim())) return;
    const get=key=>mapping[key]!==undefined ? String(row[Number(mapping[key])]??'').trim() : '';
    const name=[get('name'),get('surname')].filter(Boolean).join(' '),email=get('email'),phone=get('phone');
    const issues=[];
    if (JSON.stringify(row).length > 100000) issues.push("Fila demasiado extensa; divide las notas o adjuntos");
    if(!name) issues.push('Falta nombre');
    if(!email&&!phone) issues.push('Falta teléfono o correo para identificar al cliente');
    if(email&&!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) issues.push('Correo inválido');
    if(phone&&phone.replace(/\D/g,'').length<8) issues.push('Teléfono incompleto');
    const count=get('importedTotalBookings');
    if(count&&(!/^\d+$/.test(count))) issues.push('Cantidad de reservas inválida');
    for(const identity of [phone&&'p:'+(phone.replace(/\D/g,'').length===8?'507':'')+phone.replace(/\D/g,''),email&&'e:'+email.toLowerCase()].filter(Boolean)) {
      if(seen.has(identity)) issues.push(`Contacto repetido con fila ${seen.get(identity)}; revisa antes de importar`);
      else seen.set(identity,index+2);
    }
    if(issues.length) errors.push({row:index+2,message:issues.join(' · ')});
    customers.push({name,phone,email,notes:get('notes'),tags:get('tags').split(/[;,|]/).map(x=>x.trim()).filter(Boolean),
      importedTotalBookings:Number(count||0),importedLastBookingAtText:get('importedLastBookingAtText'),
      importedProfile:{source,externalId:get('externalId'),birthday:get('birthday'),address:get('address'),
        fields:headers.map((label,i)=>({label:String(label||`Columna ${i+1}`),value:String(row[i]??'')})).filter(x=>x.value)},
      whatsappOptOut:true,whatsappOptIn:false,customerWhatsappConsent:false});
  });
  return {customers,errors};
}
